import { Tooltip } from 'antd';
import { Text } from '@g2u/ui-kit';
import { InfoCircleOutlined } from '@ant-design/icons';

import { WithOptionalDataTest } from 'types';
import styles from './customer-extra-info.module.scss';

enum Type {
  Discount,
  Prepaid,
}

type Props = {
  type: Type;
  items?: CustomerExtraInfo.Item[];
} & WithOptionalDataTest;

export const CustomerExtraInfo = (props: Props) => {
  const { items, type, dataTestId } = props;

  if (!items || !items?.length) return null;

  return (
    <div className={styles.customerExtraInfo} data-testid={dataTestId}>
      {items?.map((item, index) => (
        <div key={index} className={styles.customerExtraInfo__item}>
          {type === CustomerExtraInfo.Type.Discount && (
            <>
              Discount <Text.$ type="danger">{item.label}</Text.$> applied to this account.
            </>
          )}
          {type === CustomerExtraInfo.Type.Prepaid && (
            <>
              The prepaid service <Text.$ type="danger">{item.label}</Text.$> will be added to the booking.
            </>
          )}
          {item.tooltip && (
            <>
              {' '}
              <Tooltip title={item.tooltip}>
                <InfoCircleOutlined className={styles.customerExtraInfo__icon} />
              </Tooltip>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

CustomerExtraInfo.Type = Type;
export namespace CustomerExtraInfo {
  export type Item = {
    label: string;
    tooltip?: string;
  };
}
